/*
 *
 *  * Copyright 2016-2017 the original author or authors.
 *  *
 *  * Licensed under the Apache License, Version 2.0 (the "License");
 *  * you may not use this file except in compliance with the License.
 *  * You may obtain a copy of the License at
 *  *
 *  *      http://www.apache.org/licenses/LICENSE-2.0
 *  *
 *  * Unless required by applicable law or agreed to in writing, software
 *  * distributed under the License is distributed on an "AS IS" BASIS,
 *  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  * See the License for the specific language governing permissions and
 *  * limitations under the License.
 *
 */

/**
 * @author Vitaliy Fedoriv
 */

import {RouterModule, Routes} from '@angular/router';
import {VetListComponent} from './vet-list/vet-list.component';
import {VetAddComponent} from './vet-add/vet-add.component';
import {VetEditComponent} from './vet-edit/vet-edit.component';
import {NgModule} from '@angular/core';
import {VetResolver} from './vet-resolver';
import {SpecResolver} from '../specialties/spec-resolver';

const vetRoutes: Routes = [
  {path: 'vets', component: VetListComponent},
  {path: 'vets/add', component: VetAddComponent},
  {path: 'vets/:id/edit', component: VetEditComponent, resolve: {vet: VetResolver, specs: SpecResolver}}
];

@NgModule({
  imports: [RouterModule.forChild(vetRoutes)],
  exports: [RouterModule]
})

export class VetsRoutingModule {
}
